module.exports = __webpack_public_path__ + "img/ico_social_linkedin--gray.8bf277d2.svg";